'use client';

/**
 * Empty-state canvas for the candidate coaching (bestie-chat) view. Interview stories now live
 * on the separate Interviews page (/stories), so coaching shows only the Bestie chat — this is
 * a plain canvas until the user starts a chat from the CandidatePromptBar.
 */
export const CoachingLanding = () => <section className="grow bg-surface-100" />;
